import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext, useState } from "react";
import { EmployeeContext } from "../../context/EmployeeContext";
import { isAdmin } from "../../utils/util";
import { SoecoButton } from "../../components/SoecoButton";
import { ClipboardList, PackagePlus, TextSearch } from "lucide-react";

export const MenuIcons = () => {
    const theme = useTheme();
    const { employee } = useContext(EmployeeContext);
    const navigate = useNavigate();

    const [hovered, setHovered] = useState(false);

    return (
        <MenuWrapper>
            {isAdmin(employee) ? (
                <>
                    <SoecoButton icon onClick={() => navigate("/admin")}>
                        <IconWrapper>
                            <ClipboardList
                                style={{
                                    color: theme.palette.primary.main,
                                    transition: "color 0.2s ease",
                                }}
                                size={96}
                                onMouseEnter={e =>
                                    (e.currentTarget.style.color = theme.palette.secondary.main)
                                }
                                onMouseLeave={e =>
                                    (e.currentTarget.style.color = theme.palette.primary.main)
                                }
                            />
                        </IconWrapper>
                    </SoecoButton>
                    <Typography
                        color="#8c8c8c"
                        fontWeight={600}
                        fontSize={24}
                        marginTop={"4px"}
                        sx={{ fontFamily: "Inter, sans-serif" }}
                    >
                        Admin
                    </Typography>
                </>
            ) : (
                <></>
            )}
            <SoecoButton
                icon
                onClick={() => navigate(`/companies/${employee.companyId}/createInventory`)}
            >
                <IconWrapper>
                    <PackagePlus
                        style={{
                            color: theme.palette.primary.main,
                            transition: "color 0.2s ease",
                        }}
                        size={96}
                        onMouseEnter={e =>
                            (e.currentTarget.style.color = theme.palette.secondary.main)
                        }
                        onMouseLeave={e =>
                            (e.currentTarget.style.color = theme.palette.primary.main)
                        }
                    />
                </IconWrapper>
            </SoecoButton>
            <Typography
                color="#8c8c8c"
                fontWeight={600}
                fontSize={24}
                marginTop={"4px"}
                sx={{ fontFamily: "Inter, sans-serif" }}
            >
                Create Inventory
            </Typography>
            <SoecoButton
                icon
                onClick={() => navigate(`/companies/${employee.companyId}/inventories/`)}
            >
                <IconWrapper>
                    <TextSearch
                        style={{
                            color: theme.palette.primary.main,
                            transition: "color 0.2s ease",
                        }}
                        size={96}
                        onMouseEnter={e =>
                            (e.currentTarget.style.color = theme.palette.secondary.main)
                        }
                        onMouseLeave={e =>
                            (e.currentTarget.style.color = theme.palette.primary.main)
                        }
                    />
                </IconWrapper>
            </SoecoButton>
            <Typography
                color="#8c8c8c"
                fontWeight={600}
                fontSize={24}
                marginTop={"4px"}
                sx={{ fontFamily: "Inter, sans-serif" }}
            >
                Inventory List
            </Typography>
        </MenuWrapper>
    );
};

const MenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 50px;
    margin-bottom: 50px;
`;

const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 130px;
    @media (max-width: 400px) {
        font-size: 100px;
    }
`;
